import { makeRequest } from '../../../lib/api';
import {
  CreatePositionRequest,
  GetPositionsRequest,
  EditPositionRequest,
} from '../api/positionApi';

const POSITION_PATH = '/v1/nomenclature';

const positionController = {
  getPositions: (request: GetPositionsRequest): Promise<any> => {
    const showDeletedString = request.showDeleted ? '?showDeleted=true' : '';
    return makeRequest('get', `${ POSITION_PATH }${ showDeletedString }`);
  },

  createPosition: (request: CreatePositionRequest): Promise<any> => {
    return makeRequest('post', POSITION_PATH, request);
  },

  editPosition: (id: string, request: EditPositionRequest): Promise<any> => {
    return makeRequest('put', `${ POSITION_PATH }/${ id }`, request);
  },

  deletePosition: (id: string): Promise<any> => {
    return makeRequest('delete', `${ POSITION_PATH }/${ id }`);
  },

  // восстановление удалённой позиции
  restorePosition: (id: string): Promise<any> => {
    return makeRequest('post', `${ POSITION_PATH }/${ id }`);
  },

  // "облегчённый" список позиций - для select-ов будем использовать
  getPositionsShort: (request: GetPositionsRequest): Promise<any> => {
    const showDeletedString = request.showDeleted ? '?showDeleted=true' : '';
    return makeRequest('get', `${ POSITION_PATH }/short${ showDeletedString }`);
  },
};

export { positionController };
